export default __webpack_public_path__ + "static/media/datamynt-name-horizontal.8b93483a.svg";